// extracted by mini-css-extract-plugin
module.exports = {"StackList":"StackList_StackList__3kDCW","fadeIn":"StackList_fadeIn__1xnYz","modalFadeIn":"StackList_modalFadeIn__3SR4K","slideInFromRight":"StackList_slideInFromRight__PSjgu"};